module.exports = __webpack_public_path__ + "static/media/sh.93c31550.svg";